/** Tiptap node names for custom/group sections (single module avoids extension↔extension cycles). */

export const RlGroupSectionName = 'RL_GROUP_SECTION';
export const RlCustomSectionName = 'RL_CUSTOM_SECTION';
